import { Account as AccountItem } from '../transactions-sidepanels/types';

export interface PrimaryAccount {
  description: string;
  groupId: string;
  id: string;
  number: string;
}

export interface Group {
  categoryId: string;
  description: string;
  id: string;
  number: string;
  primaryAccounts: PrimaryAccount[];
}

export interface AccountCategories {
  id: string;
  name: string;
  number: string;
  accountGroups: Group[];
}

export interface Category {
  id: string;
  name: string;
  number: string;
  accountGroups: Group[];
}

export enum AccountSelectorSize {
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL',
}

export enum AccountSelectorPosition {
  TOP = 'TOP',
  BOTTOM = 'BOTTOM',
}

export interface AccountSelectorProps {
  className?: string;
  fullWidth?: boolean;
  accounts?: AccountCategories[];
  placeholder: string;
  isLoading?: boolean;
  accountsIsLoading?: boolean;
  setAccountQuery: (query: string) => void;
  accountsList?: AccountItem[];
  setSelectedAccount: (number: string) => void;
  selectedAccount?: string;
  setAccounts: (data: AccountItem[]) => void;
  onSearch?: (searchText: string) => void;
  title?: string;
  position?: AccountSelectorPosition;
  size?: AccountSelectorSize;
  error?: string;
  disabled?: boolean;
  tabIndex?: number;
  transactionAccountSelector?: boolean;
  multiple?: boolean;
  setSelectedAccountsList?: (data: AccountItem[]) => void;
  selectedAccountsList?: AccountItem[];
  primaryAccountsSelector?: boolean;
  selectedPrimaryAccountsList?: string[];
  setSelectedPrimaryAccounts?: (data: string[]) => void;
}

export interface AccountsListTypes {
  onBack: () => void;
  selectedCategoryNumber?: string;
  selectedGroupNumber?: string;
  selectedPrimaryAccount?: PrimaryAccount;
  accountsIsLoading?: boolean;
  accounts?: AccountItem[];
  setSelectedAccount: (number: string) => void;
  account?: AccountItem;
  toggle: (toggledOn: boolean) => void;
  setAccount: (data: AccountItem) => void;
  setSelectedCategoryId: (categoryId: string) => void;
  setSelectedGroupId: (groupId: string) => void;
  setSelectedPrimaryAccountId: (primaryId: string) => void;
  multiple?: boolean;
  selectedAccounts?: AccountItem[];
  setSelectedAccounts: (data: AccountItem[]) => void;
}

export interface CategoriesListTypes {
  accounts?: AccountCategories[];
  setSelectedCategoryId: (categoryId: string) => void;
  primaryAccountsSelector?: boolean;
  setSelectedPrimaryAccounts?: (data: string[]) => void;
  selectedPrimaryAccountsList?: string[];
}

export interface GroupsListTypes {
  selectedCategory?: Category;
  setSelectedGroupId: (groupId: string) => void;
  onBack: () => void;
  primaryAccountsSelector?: boolean;
  setSelectedPrimaryAccounts?: (data: string[]) => void;
  selectedPrimaryAccountsList?: string[];
}

export interface PrimaryAccountsListTypes {
  selectedGroup?: Group;
  setSelectedPrimaryAccountId: (primaryAccountId: string) => void;
  onBack: () => void;
  selectedCategoryNumber?: string;
  setAccountQuery: (query: string) => void;
  selectedCategoryId?: string;
  primaryAccountsSelector?: boolean;
  setSelectedPrimaryAccounts?: (data: string[]) => void;
  selectedPrimaryAccountsList?: string[];
}
